import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_LIST_BY_STAY_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_CALENDAR_QUERY } from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
	from: string;
	to: string;
};
type Result = {
	reservationListByStayDateQueryData: Type.QueryData.ReservationListQueryData;
};

export const useReservationListByStayDateDateQuery = ({ hotelID, from, to }: Props): Result => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_LIST_BY_STAY_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_CALENDAR_QUERY,
		{ variables: { hotelID, from, to } },
	);

	const { onConvertQueryData } = Converter.useReservationListByStayDateQueryData();
	const { queryData } = onConvertQueryData({ serverData: data });

	return {
		reservationListByStayDateQueryData: queryData,
	};
};
